module.exports = __webpack_public_path__ + "static/media/sakya-default.b224358a.jpg";